import { reactLocalStorage } from 'reactjs-localstorage';

import Const from '../util/Constants';
import DateUtil from '../util/Util';

class SalesOrderController {

  static Staff = 'responsible_person';

  static addModel = fields => {
    const user = reactLocalStorage.getObject(Const.LoggedInUser).user_id;

    let sales ={};
    const keys = Object.keys(fields);
    for(let i = 0; i < keys.length; i++) {
      if(!fields[keys[i]].editable) continue;
      const fieldType = fields[keys[i]].field_type;
      const val = fields[keys[i]].default_value;
      if(fieldType === Const.Date || fieldType === Const.DateTime) {
        sales[keys[i]] = '';
        if(val === 'today') sales[keys[i]] = DateUtil.dateToServerDateTime(new Date());
      } else if(fieldType === Const.Address) {
        sales[keys[i]] = [];
      } else if(keys[i] === SalesOrderController.Staff) {
        sales[keys[i]] = '~' + user + '~';
      } else if(fieldType.includes(Const.MultiSelect)) {
        sales[keys[i]] = '';
        if(val && val !== '') sales[keys[i]] = '~' + val.replace(',', '~') + '~';
      } else {
        sales[keys[i]] = val;
      }
    }
    sales.status = Const.Active;
    return sales;
  }

  static getCustomFields = fields => {
    let customField = {};
    let keys = Object.keys(fields);
    for(let i = 0; i < keys.length; i++) {
      if(keys[i].includes('custom_') || keys[i] === 'description') {
        customField[keys[i]] = fields[keys[i]];
      }
    }
    return customField;
  }
}
export default SalesOrderController;